/**
 * Copyright 2022 Design Barn Inc.
 */

import { BASE_PLAYER_WIDTH } from './constants';

export const getLottieWidth = (viewportWidth: number, scale: number): number => {
  return (viewportWidth * BASE_PLAYER_WIDTH * scale) / 100;
};
